// extracted by mini-css-extract-plugin
export default {"bottomCtas":"VerifyOtp_bottomCtas__oT4KR","waitAndAction":"VerifyOtp_waitAndAction__EOUDI"};